import { render, staticRenderFns } from "./add-device-external-edit.vue?vue&type=template&id=dd58e4d6&scoped=true&"
import script from "./add-device-external-edit.js?vue&type=script&lang=js&"
export * from "./add-device-external-edit.js?vue&type=script&lang=js&"
import style0 from "./add-device-external-edit.css?vue&type=style&index=0&id=dd58e4d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd58e4d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
